import * as React from 'react';
import { APIError } from '../../api';
import { ErrorName } from '../../enums/ErrorName';
import { AlertType } from '../../types/AlertType';
import { Alert } from 'rcd-cpp-ui/ui/alert/Alert';

interface AdditionalInfo {
  duplicateRefId: string;
  linkText?: string;
  additionalText?: string;
}

export class DuplicateFieldError extends APIError<AdditionalInfo> {
  constructor(
    message: string,
    info: AdditionalInfo,
    type: AlertType = 'error'
  ) {
    super(message, info, type, ErrorName.DuplicateFieldError);
  }
}

type Props = { error: DuplicateFieldError; onClose: () => void };

export const DuplicateFieldErrorAlert = ({ error, onClose }: Props) => {
  const { duplicateRefId, linkText, additionalText } =
    error?.additionalInfo || {};

  if (!duplicateRefId) {
    return (
      <Alert type={error.type as any} onClose={onClose}>
        {error.message}
      </Alert>
    );
  }

  const displayLinkText = linkText || 'Open the Question';
  const displayAdditionalText = additionalText || '';
  const url = new URL(window.location.href);
  url.searchParams.set('id', duplicateRefId);

  return (
    <Alert type={error.type as any} onClose={onClose}>
      <a
        href={url.pathname + url.search}
        target="_blank"
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        {displayLinkText}
      </a>
      <span>{displayAdditionalText}</span>
    </Alert>
  );
};
